import { Component, input, output } from '@angular/core';
import { UmssIconComponent } from '../icon/icon.component';
import { fadeIn } from '../../animations';

@Component({
  selector: 'umss-bottom-action-bar',
  standalone: true,
  imports: [UmssIconComponent],
  templateUrl: './bottom-action-bar.component.html',
  styleUrls: ['./bottom-action-bar.component.scss'],
  animations: [fadeIn],
  host: { '[@fadeIn]': '' }
})
export class UmssBottomActionBarComponent {
  backgroundColor = input<string>('var(--color-Primary)');
  title = input.required<string>();
  subtitle = input<string>('');
  iconName = input<string>('phosphorArrowRight');

  actionClick = output<void>();
}
